import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { GetWindTurbinesPerformanceFactorList } from "@/stores/actions/WindTurbinesPerformanceFactor";
import { GET_WIND_TURBINES_CAPACITY_FACTOR } from "@/stores/actions/WindTurbinesCapacityFactor";
import UserModule from "@/stores/user/UserModule";
import {
	GetWindParkKPITable,
	GetWindParkKPITableError,
	GetWindParkKPITableSuccess,
	SetWindTurbines,
	SetWindTurbinesFC,
	SetWindTurbinesPF,
} from "@/stores/actions/WindParkKPITable";

const state = {
	status:    FetchStatus.Init,
	data:      {},
	tableData: [],
};

const actions = {
	[GetWindParkKPITable]: ({ commit, dispatch }, turbinesStatus) =>
	{
		commit(GetWindParkKPITable);
		const turbinesIds = (turbinesStatus || []).map(turbine => turbine.monitoringElementId);

		dispatch(SetWindTurbines, turbinesStatus);
		dispatch(GetWindTurbinesPerformanceFactorList, turbinesIds);
		dispatch(GET_WIND_TURBINES_CAPACITY_FACTOR, turbinesIds);
		commit(GetWindParkKPITableSuccess);
	},
	[SetWindTurbines]: ({ commit }, turbinesStatus) =>
	{
		commit(SetWindTurbines, turbinesStatus);
	},
	[SetWindTurbinesPF]: ({ commit }, performanceFactor) =>
	{
		commit(SetWindTurbinesPF, performanceFactor);
	},
	[SetWindTurbinesFC]: ({ commit }, capacityFactor) =>
	{
		commit(SetWindTurbinesFC, capacityFactor);
	},
};

const mutations = {
	[GetWindParkKPITable]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetWindParkKPITableSuccess]: (state) =>
	{
		state.status = FetchStatus.Loaded;
	},
	[SetWindTurbines]: (state, turbinesStatus) =>
	{
		const updatedTurbineStatus = [];
		for (let i = 0; i < turbinesStatus.length; i++)
		{
			const turbineStatus = turbinesStatus[i];
			const status = {
				id:                turbineStatus.monitoringElementId,
				name:              turbineStatus.name,
				kpiValue:          turbineStatus.kpiValue,
				kpiUnit:           turbineStatus.kpiUnit,
				performanceFactor: "-",
				capacityFactor:    "-",
				isOnline:          turbineStatus.connectionStatus.isOnline,
			};
			updatedTurbineStatus.push(status);
		}

		// Ordenar decrescente, tratando nulos como -Infinity (vão pro final)
		updatedTurbineStatus.sort((a, b) => (b.kpiValue ?? -Infinity) - (a.kpiValue ?? -Infinity));

		state.tableData = updatedTurbineStatus;
	},
	[SetWindTurbinesPF]: (state, resp) =>
	{
		resp.forEach((pf) =>
		{
			const index = state.tableData.map(kpi => kpi.id).lastIndexOf(pf.monitoringElementId);

			if (pf.value >= 0)
			{
				state.tableData[index].performanceFactor = (pf.value * 100).toFixed(2);
			}
		});
	},
	[SetWindTurbinesFC]: (state, resp) =>
	{
		resp.forEach((fc) =>
		{
			const index = state.tableData.map(kpi => kpi.id).lastIndexOf(fc.monitoringElementId);

			state.tableData[index].capacityFactor = (fc.capacityFactorValue * 100).toFixed(2);
		});
	},
};

export default {
	state,
	actions,
	mutations,
};
